import { t } from "ttag";

import { ToolbarButton } from "metabase/common/components/ToolbarButton";
import { useDashboardContext } from "metabase/dashboard/context/context";
import { useSelector } from "metabase/redux";
import { getUserIsAdmin } from "metabase/selectors/user";

export const FullscreenToggle = () => {
  const { isFullscreen, onFullscreenChange } = useDashboardContext();
  const label = isFullscreen ? t`Exit fullscreen` : t`Enter fullscreen`;
  // const isAdmin = useSelector(getUserIsAdmin);
  
  // TODOGHOST
  if (!isFullscreen) {
    return null;
  }

  return (
    <ToolbarButton
      tooltipLabel={label}
      icon={isFullscreen ? "contract" : "expand"}
      onClick={(e) => onFullscreenChange(!isFullscreen, !e.altKey)}
      aria-label={label}
    />
  );
};
